"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveShortcutProvider = SaveShortcutProvider;
exports.useDirtyLabels = useDirtyLabels;
exports.useSaveAll = useSaveAll;
exports.useSaveShortcut = useSaveShortcut;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var SaveShortcutContext = (0, react_2.createContext)(null);
function SaveShortcutProvider(props) {
    var _this = this;
    // A ref, not state: registering a handler must never re-render the tree.
    var entriesRef = (0, react_2.useRef)(new Set());
    // Guards against a second press while the first round is still in flight.
    var isSavingRef = (0, react_2.useRef)(false);
    var register = (0, react_2.useCallback)(function (entry) {
        entriesRef.current.add(entry);
        return function () {
            entriesRef.current.delete(entry);
        };
    }, []);
    var saveAll = (0, react_2.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var active, failed, _i, active_1, entry, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (isSavingRef.current)
                        return [2 /*return*/];
                    active = Array.from(entriesRef.current).filter(function (e) {
                        try {
                            return e.isEnabled();
                        }
                        catch (_a) {
                            return false;
                        }
                    });
                    if (active.length === 0) {
                        (0, react_1.addToast)({ title: "Nothing to save", description: "There are no unsaved changes on this screen.", color: "primary" });
                        return [2 /*return*/];
                    }
                    isSavingRef.current = true;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 8, 9]);
                    failed = [];
                    _i = 0, active_1 = active;
                    _b.label = 2;
                case 2:
                    if (!(_i < active_1.length)) return [3 /*break*/, 7];
                    entry = active_1[_i];
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, entry.handler()];
                case 4:
                    _b.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _a = _b.sent();
                    failed.push(entry.label);
                    return [3 /*break*/, 6];
                case 6:
                    _i++;
                    return [3 /*break*/, 2];
                case 7:
                    if (failed.length > 0) {
                        (0, react_1.addToast)({ title: "Some changes were not saved", description: failed.join(", "), color: "danger" });
                    }
                    return [3 /*break*/, 9];
                case 8:
                    isSavingRef.current = false;
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); }, []);
    var getDirtyLabels = (0, react_2.useCallback)(function () {
        return Array.from(entriesRef.current)
            .filter(function (e) {
            try {
                return e.isEnabled() && e.isDirty();
            }
            catch (_a) {
                return false;
            }
        })
            .map(function (e) { return e.label; });
    }, []);
    (0, react_2.useEffect)(function () {
        var onKeyDown = function (e) {
            // `code` rather than `key`: with Shift held, `key` is "S" on a US layout but varies elsewhere,
            // whereas KeyS is the physical key regardless of layout.
            if (e.code !== "KeyS" || !e.shiftKey)
                return;
            if (!e.ctrlKey && !e.metaKey)
                return;
            e.preventDefault();
            void saveAll();
        };
        window.addEventListener("keydown", onKeyDown);
        return function () { return window.removeEventListener("keydown", onKeyDown); };
    }, [saveAll]);
    var value = (0, react_2.useMemo)(function () { return ({ register: register, saveAll: saveAll, getDirtyLabels: getDirtyLabels }); }, [register, saveAll, getDirtyLabels]);
    return (0, jsx_runtime_1.jsx)(SaveShortcutContext.Provider, { value: value, children: props.children });
}
/**
 * Registers this screen's save action with the Ctrl/Cmd + Shift + S shortcut.
 *
 * `handler` and `isEnabled` are read through a ref, so they always see the latest render's closure
 * without the registration churning on every keystroke in the form.
 *
 *   useSaveShortcut({
 *     label: "Tenant information",
 *     isEnabled: () => !isViewMode && pendingChanges.length > 0,
 *     handler: handleSave,
 *   });
 */
function useSaveShortcut(options) {
    var ctx = (0, react_2.useContext)(SaveShortcutContext);
    var latest = (0, react_2.useRef)(options);
    latest.current = options;
    (0, react_2.useEffect)(function () {
        if (!ctx)
            return;
        return ctx.register({
            label: latest.current.label,
            handler: function () { return latest.current.handler(); },
            isEnabled: function () { return (latest.current.isEnabled ? latest.current.isEnabled() : true); },
            isDirty: function () { return (latest.current.isDirty ? latest.current.isDirty() : false); },
        });
    }, [ctx]);
}
/** Lets a "Save all" button run the same set of handlers the shortcut would. */
function useSaveAll() {
    var ctx = (0, react_2.useContext)(SaveShortcutContext);
    return ctx === null || ctx === void 0 ? void 0 : ctx.saveAll;
}
/**
 * ATOC-1 C2: lets a wizard ask "is there anything unsaved on this step?" before moving off it.
 * Returns a getter rather than a value — the answer must be read at click time, not at render time.
 */
function useDirtyLabels() {
    var _a;
    var ctx = (0, react_2.useContext)(SaveShortcutContext);
    return (_a = ctx === null || ctx === void 0 ? void 0 : ctx.getDirtyLabels) !== null && _a !== void 0 ? _a : (function () { return []; });
}
